__webpack_require__.b = new URL("./", import.meta.url);

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"transformers": 0
};

// no install chunk

// no chunk on demand loading

// no prefetching

// no preloaded

// no external install chunk

// no on chunks loaded